<script>
    import CourseCardsComponent from '../../components/pagesbuilder/dynamic-components/CourseCardsComponent.vue';
    import PreviewComponent from './PreviewComponent.vue';
    import CardActionsMixin from "../../author/pagesbuilder/mixins/CardActionsMixin";

    import {mapState} from 'vuex';

    export default {
        name: "PreviewCourseCardsComponent",
        mixins: [
            PreviewComponent,
            CardActionsMixin,
            CourseCardsComponent
        ],
        data () {
          return {
              enableHref: true,
          }
        },
        computed: {
            ...mapState('pages',[
                'pageContext'
            ])
        },
        mounted () {
            window.setTimeout( () => {
                if (this.pageContext.params && this.pageContext.params.searchterm) {
                    this.setBothFilters({primaryFilterKey:"bySearchTerm",secondaryFilterKey: this.pageContext.params.searchterm})
                }
            },100)
        },
        methods: {
            addCardListeners ()
            {
                this.componentNode.querySelectorAll('[data-href]').forEach((link) => {
                    let href = link.getAttribute("data-href");
                    if (href && href !== "javascript:void(0)") {
                        link.addEventListener('click', (e) => {
                            e.stopPropagation();
                            this.open(href);
                        });
                    }

                });
            },
            loadMoreClicked () {
                let rows = this.getRows();

                if (rows) {
                    rows++
                } else {
                    rows = 1;
                }

                this.changeMyData({
                    rows
                })
            },
            open (url) {
                if (this.getCardOpenTarget() === 'new') {
                    window.open(url);
                } else {
                    document.location.href = url;
                }
            }
        }
    }
</script>
